"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsOut = void 0;
class SettingsOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return SettingsOut.attributeTypeMap;
    }
}
exports.SettingsOut = SettingsOut;
SettingsOut.discriminator = undefined;
SettingsOut.attributeTypeMap = [
    {
        "name": "colorPaletteDark",
        "baseName": "colorPaletteDark",
        "type": "CustomColorPalette",
        "format": ""
    },
    {
        "name": "colorPaletteLight",
        "baseName": "colorPaletteLight",
        "type": "CustomColorPalette",
        "format": ""
    },
    {
        "name": "customBaseFontSize",
        "baseName": "customBaseFontSize",
        "type": "number",
        "format": "int"
    },
    {
        "name": "customColor",
        "baseName": "customColor",
        "type": "string",
        "format": ""
    },
    {
        "name": "customFontFamily",
        "baseName": "customFontFamily",
        "type": "string",
        "format": ""
    },
    {
        "name": "customFontFamilyUrl",
        "baseName": "customFontFamilyUrl",
        "type": "URI",
        "format": "uri"
    },
    {
        "name": "customLogoUrl",
        "baseName": "customLogoUrl",
        "type": "URI",
        "format": "uri"
    },
    {
        "name": "customThemeOverride",
        "baseName": "customThemeOverride",
        "type": "CustomThemeOverride",
        "format": ""
    },
    {
        "name": "disableEndpointOnFailure",
        "baseName": "disableEndpointOnFailure",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "displayName",
        "baseName": "displayName",
        "type": "string",
        "format": ""
    },
    {
        "name": "enableChannels",
        "baseName": "enableChannels",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "enableIntegrationManagement",
        "baseName": "enableIntegrationManagement",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "enableTransformations",
        "baseName": "enableTransformations",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "enforceHttps",
        "baseName": "enforceHttps",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "eventCatalogPublished",
        "baseName": "eventCatalogPublished",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "readOnly",
        "baseName": "readOnly",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "showUseSvixPlay",
        "baseName": "showUseSvixPlay",
        "type": "boolean",
        "format": ""
    }
];
//# sourceMappingURL=SettingsOut.js.map